import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const modalTriggerStyles = ({ theme }) => css`
  label: modal-trigger;

  color: ${theme.colors.p500};
  cursor: pointer;
`

export const ModalTrigger = styled(Text)(modalTriggerStyles)
